import { createFileRoute } from "@tanstack/react-router";

import SecuritySuccess from "@/features/security/SecuritySuccess";

export const Route = createFileRoute("/_auth/security-success")({
  component: SecuritySuccess,
});
